/* eslint-disable */
export default {
  onSearching: 'Carregando...',
  noContacts: 'Nenhum registro encontrado.',
} as const;

// @key: @#@"onSearching"@#@ @source: @#@"Loading..."@#@
// @key: @#@"noContacts"@#@ @source: @#@"No records found."@#@
